import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../constant/api";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token"),
  );

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser
      ? JSON.parse(storedUser)
      : {
          user_name: "",
          user_type: "",
          email: "",
        };
  });

  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (token && !isAuthenticated) {
      setIsAuthenticated(true);
    }
    if (storedUser && (!user || !user.user_name)) {
      setUser(JSON.parse(storedUser));
    }
  }, []); // This effect runs only once on mount.

  const logout = async () => {
    const token = localStorage.getItem("token");
    const refresh = localStorage.getItem("refresh");

    if (!token) {
      console.error("No token found. Please log in first.");
      setIsAuthenticated(false);
      setUser({ user_name: "", user_type: "", email: "" });
      localStorage.clear();
      setError("No token found. Please log in first.");
      return;
    }

    try {
      await axios.post(
        `${BASE_URL}/accounts/logout/`,
        { refresh },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        },
      );

      setIsAuthenticated(false);
      setUser({ user_name: "", user_type: "", email: "" });
      localStorage.clear();
      setError(null);

      const sessionResponse = await axios.get(
        `${BASE_URL}/accounts/webcreate-sessionid/`,
      );
      localStorage.setItem("sessionid", sessionResponse.data.sessionid);

      navigate("/"); //  Redirect using useNavigate
    } catch (error) {
      console.error("Error during logout:", error);
      localStorage.clear();
      setIsAuthenticated(false);
      setError(
        error.response?.data?.detail || "Logout failed. Please try again.",
      );
      navigate("/"); //  Redirect using useNavigate even on error
    }
  };

  // otp login mobile and email new implementation

  const RequestOTP = async (formData) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/otp/login/request/`,
        formData,
      );

      return response.data; // ✅ REQUIRED
    } catch (error) {
      throw error; // let UI handle it
    }
  };

  // verify otp

  const login = async (formData) => {
    const sessionId = localStorage.getItem("sessionid");
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/login/`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-id": sessionId,
          },
        },
      );
      console.log("Login Response:", response);
      const userData = {
        user_name: response.data.Data.user_name,
        user_type: response.data.Data.user_type,
        email: response.data.Data.email,
        is_approved: response.data.Data.is_approved || false,
      };

      localStorage.setItem("token", response.data.Data.access);
      localStorage.setItem("refresh", response.data.Data.refresh);
      localStorage.setItem("user", JSON.stringify(userData));

      setUser(userData);
      setIsAuthenticated(true);
      setError(null);

      if (userData.user_type === "seller") {
        if (userData.is_approved === "Pending") {
          navigate("/seller/pending"); //  Pending approval
        } else if (userData.is_approved === "Rejected") {
          navigate("/seller/rejected"); //  Rejected
        } else if (userData.is_approved === "Confirmed") {
          navigate("/seller"); //  Confirmed - dashboard
        }
      } else if (userData.user_type === "customer") {
        navigate("/"); //  Redirect customer to home page
      } else if (userData.user_type === "admin") {
        navigate("/admin"); // Redirect admin to dashboard
      }

      return { success: true, message: response.data.message };
    } catch (error) {
      console.error("Error during Login!", error);
      setError(
        error.response?.data?.message || "Login failed. Please try again.",
      );
      return {
        success: false,
        message: error.response?.data || "Login failed.",
      };
    }
  };

  const Sellerlogin = async (formData) => {
    const sessionId = localStorage.getItem("sessionid");
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/seller/login/`,

        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-id": sessionId,
          },
        },
      );

      console.log("sellerLogin Response:", response);
      const userData = {
        user_name: response.data.Data.user_name,
        user_type: response.data.Data.user_type,
        email: response.data.Data.email,
        is_approved: response.data.Data.is_approved || false,
      };
      console.log("userData", userData);

      localStorage.setItem("token", response.data.Data.access);
      localStorage.setItem("refresh", response.data.Data.refresh);
      localStorage.setItem("user", JSON.stringify(userData));

      setUser(userData);
      setIsAuthenticated(true);
      setError(null);

      if (userData.user_type === "seller") {
        if (userData.is_approved === "Pending") {
          navigate("/seller/pending"); //  Pending approval
        } else if (userData.is_approved === "Rejected") {
          navigate("/seller/rejected"); //  Rejected
        } else if (userData.is_approved === "Confirmed") {
          navigate("/seller"); //  Confirmed - dashboard
        }
      } else if (userData.user_type === "customer") {
        navigate("/"); //  Redirect customer to home page
      } else if (userData.user_type === "admin") {
        navigate("/admin"); // Redirect admin to dashboard
      } else if (userData.user_type === "subadmin") {
        navigate("/subadmin"); // Redirect subadmin to dashboard
      }

      return { success: true, message: response.data.message };
    } catch (error) {
      console.error("Error during Login!", error);
      setError(
        error.response?.data?.message || "Login failed. Please try again.",
      );
      return { success: false, message: error.response?.data };
    }
  };
  const Adminlogin = async (formData) => {
    const sessionId = localStorage.getItem("sessionid");
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/admin/login/`,

        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-id": sessionId,
          },
        },
      );

      console.log("adminLogin Response:", response);
      const userData = {
        user_name: response.data.Data.user_name,
        user_type: response.data.Data.user_type,
        email: response.data.Data.email,
        is_approved: response.data.Data.is_approved || false,
      };

      localStorage.setItem("token", response.data.Data.access);
      localStorage.setItem("refresh", response.data.Data.refresh);
      localStorage.setItem("user", JSON.stringify(userData));

      setUser(userData);
      setIsAuthenticated(true);
      setError(null);
      if (userData.user_type === "admin") {
        navigate("/admin"); // Redirect admin to dashboard
      } else if (userData.user_type === "subadmin") {
        navigate("/subadmin"); // Redirect subadmin to dashboard
      }

      return { success: true, message: response.data.message };
    } catch (error) {
      console.error("Error during Login!", error);
      setError(
        error.response?.data?.message || "Login failed. Please try again.",
      );
      return { success: false, message: error.response?.data };
    }
  };

  /**
   * Request an OTP to be sent to the user's email.
   * @param {string} email - The user's email address.
   * @returns {object} - { success: boolean, message: string }
   */
  const requestOTP = async (formData) => {
    console.log(formData);

    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/otp/login/request/`,
        formData,
        { headers: { "Content-Type": "application/json" } },
      );
      // Assume the backend sends a success message.
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error("Error requesting OTP", error);
      const errorMessage =
        error.response?.data.message ||
        "Failed to request OTP. Please try again.";
      return { success: false, message: errorMessage };
    }
  };

  const verifyOTP = async (formData) => {
    console.log("verify otp formdata", formData);

    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/otp/login/verify/`,
        formData,
      );
      console.log("OTP Verification Response:", response);
      const payload = response?.data;
      const data = payload?.data;

      if (!data?.access) {
        return {
          success: false,
          message: payload?.message || "OTP verification failed",
        };
      }

      const needsProfile = data.is_profile_completed === false;

      return {
        success: true,
        needProfile: needsProfile,
        message: payload.message,
        auth: {
          access: data.access,
          refresh: data.refresh,
          userType: data.user_type,
        },
        profile: {
          userName: data.user_name,
          firstName: data.first_name,
          mobile: data.mobile_number,
          email: data.email,
        },
      };
    } catch (error) {
      console.error("Error verifying OTP", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "OTP verification failed. Please try again.",
      };
    }
  };

  /** ====================== Seller OTP Methods ====================== **/

  /**
   * Seller Request OTP
   * @param {string} email - Seller's email address.
   */
  const sellerRequestOTP = async (formData) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/otp/login/request/`,
        formData,
        { headers: { "Content-Type": "application/json" } },
      );
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error("Error requesting seller OTP", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Failed to request OTP. Please try again.",
      };
    }
  };

  /**
   * Seller Verify OTP
   * @param {string} email - Seller's email address.
   * @param {string} otp - OTP received by the seller.
   */
  const sellerVerifyOTP = async (formData) => {
    const sessionId = localStorage.getItem("sessionid");

    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/seller/otp/login/verify/`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-id": sessionId,
          },
        },
      );
      console.log("seller otp verify", response);
      // If seller account exists, log them in
      if (response.data.data && response.data.data.access) {
        const userData = {
          email: response.data.data.email,
          user_name: response.data.data.user_name,
          user_type: response.data.data.user_type,
          is_approved: response.data.data.is_approved || false,
        };

        localStorage.setItem("token", response.data.data.access);
        localStorage.setItem("refresh", response.data.data.refresh);
        localStorage.setItem("user", JSON.stringify(userData));

        setUser(userData);
        setIsAuthenticated(true);

        // Redirect seller to their dashboard
        navigate("/seller");
        return {
          success: true,
          message: "OTP verified. Logged in successfully.",
        };
      } else {
        // If no seller account exists, redirect to registration
        return {
          success: true,
          needRegistration: true,
          message: "OTP verified. Please complete your seller registration.",
        };
      }
    } catch (error) {
      console.error("Error verifying seller OTP", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "OTP verification failed. Please try again.",
      };
    }
  };

  const register = async (formData) => {
    const sessionId = localStorage.getItem("sessionid");
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/customer/signup/`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-id": sessionId,
          },
        },
      );

      localStorage.setItem("token", response.data.Data.access);
      localStorage.setItem("refresh", response.data.Data.refresh);
      const userData = {
        email: response.data.Data.email,
        user_name: response.data.Data.user_name,
        user_type: response.data.Data.user_type,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);
      setIsAuthenticated(true);
      navigate("/registration/successful"); // ✅ Redirect using useNavigate
      return { success: true, message: response.data.message };
    } catch (error) {
      setError(error.response?.data?.message || "Signup failed");
      return { success: false, message: error.response?.data };
    }
  };

  const SellerRegister = async (formPayload) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/seller/signup/`,
        formPayload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("API Response:", response);
      localStorage.setItem("token", response.data.Data.access);
      localStorage.setItem("refresh", response.data.Data.refresh);
      const userData = {
        email: response.data.Data.email,
        user_name: response.data.Data.user_name,
        user_type: response.data.Data.user_type,
        is_approved: response.data.Data.is_approved || false,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);
      setIsAuthenticated(true);
      navigate("/seller/pending"); 

      return {
        success: true,
        message: response.data || "Seller registered successfully.",
      };
    } catch (error) {
      console.error(
        "Error during seller registration:",
        error.response?.data || error,
      );

      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data ||
          "An unexpected error occurred.",
      };
    }
  };

  const AdminSellerRegister = async (formPayload) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/accounts/seller/signup/`,
        formPayload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("API Response:", response);

      // ✅ REMOVE token storage and automatic login
      // if (response.data.access && response.data.refresh) {
      //   localStorage.setItem("token", response.data.access);
      //   localStorage.setItem("refresh", response.data.refresh);
      // }

      console.log("Form Data:", formPayload);

      return {
        success: true,
        message: response.data,
      };
    } catch (error) {
      console.error(error.response?.data);

      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data ||
          "An unexpected error occurred.",
      };
    }
  };

  const createSubAdmin = async (subAdminData) => {
    try {
      const response = await USER_URL.post(
        "/accounts/admin/create/subadmin/",
        subAdminData,
      );

      if (response.data?.status === true || response.status === 201) {
        return {
          success: true,
          data: response.data,
        };
      }

      return {
        success: false,
        message: response.data?.message || "Creation failed",
        errors: response.data,
      };
    } catch (error) {
      console.error("Create SubAdmin Error:", error.response?.data);

      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data?.non_field_errors?.join(" ") ||
          "Something went wrong",
        errors: error.response?.data || {},
      };
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        user,
        setUser,
        login,
        RequestOTP, //new
        Sellerlogin,
        Adminlogin,
        logout,
        register,
        SellerRegister,
        AdminSellerRegister,
        createSubAdmin,
        error,
        verifyOTP,
        requestOTP,
        sellerRequestOTP, // Seller OTP Request
        sellerVerifyOTP, // Seller OTP Verification
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use AuthContext
export const useAuth = () => useContext(AuthContext);
